import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { ApplicationState } from '../../store';
import * as SessionMdl from '../../models/SessionModel';
import * as BillModel from '../../models/BillToModel';
import * as SessionStore from '../../store/Session';
import { useHistory } from 'react-router-dom';
import { SaPhone } from '../Misc/SawinComponents';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type MyProps =
    { ARList: BillModel.BillToList } & { SessionState: SessionMdl.SessionModel } & typeof SessionStore.actionCreators;

const ARPicker: React.FunctionComponent<MyProps> = (props: MyProps) => {

    return (
        <Container fluid={true}>
            {props.ARList.items.map((item, index) =>
                <Row key={index}>
                    <Col>
                        <ARPickerCard item={item} myAction={props.setSelectedAR} />
                    </Col>
                </Row>
            )}
        </Container>
    );
}

function mapToProps(state: ApplicationState) {
    return { ARList: state.billToList, SessionState: state.sessionState };
}

export default connect(
    (state: ApplicationState) => (mapToProps(state)), SessionStore.actionCreators)(ARPicker as any);

type ARPickerCardProps =
    { item: BillModel.BillToModel, myAction: Function };

const ARPickerCard: React.FunctionComponent<ARPickerCardProps> = (props: ARPickerCardProps) => {

    const history = useHistory();
    
    const handleClick = (arNum: string) => {
        props.myAction(arNum);
        history.push('/');
    }

    
        return (<div><Card className='ARPicker-card'>
            <CardHeader>
                <Row>
                    <Col>                        
                        <b> {props.item.sawinClientName} </b>
                    </Col>
                </Row>                
            </CardHeader>
            <CardBody>                
                <Row>
                    <Col>
                        {props.item.id}-{props.item.name.displayName}
                    </Col>                   
                </Row>
                <Row>
                    <Col>
                        {props.item.address.line1}
                    </Col>
                </Row>    
                <Row>
                    <Col>
                        {`${props.item.address.city}, ${props.item.address.state} ${props.item.address.zip}`}
                    </Col>
                </Row>    
                <Row>
                    <Col><br />
                        <FontAwesomeIcon icon={faPhoneAlt} /> {' '}
                        <SaPhone UnformattedPhone={props.item.phone.displayPhone} />
                    </Col> 
                    <Col className="right-align">
                        <Button onClick={() => {handleClick(props.item.id) } }>Select</Button>
                    </Col>
                </Row>    
            </CardBody>
        </Card></div>);
   
}